import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "@/api/client";
import type { Exam } from "@/types";

export default function ControllerExams() {
  const { data: exams = [], isLoading } = useQuery({
    queryKey: ["controller", "exams"],
    queryFn: () => api.get<Exam[]>("/controller/exams", { page_size: 50 }),
  });

  if (isLoading) {
    return <div className="py-12 text-center text-gray-500">Loading exams...</div>;
  }

  if (exams.length === 0) {
    return <div className="py-12 text-center text-gray-500">No exams available.</div>;
  }

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-900 mb-4">All Exams</h2>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {exams.map((exam) => (
          <Link
            key={exam.id}
            to={`/controller/exams/${exam.id}`}
            className="block rounded-lg border border-gray-200 bg-white p-5 shadow-sm hover:border-primary-400 hover:shadow-md transition-all"
          >
            <h3 className="font-semibold text-gray-900 mb-1">{exam.title}</h3>
            {exam.description && (
              <p className="text-sm text-gray-500 mb-3 line-clamp-2">{exam.description}</p>
            )}
            <div className="flex gap-4 text-xs text-gray-400">
              <span>{exam.total_questions} questions</span>
              <span>{exam.time_limit_minutes} min</span>
              <span>Pass: {exam.pass_mark}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
